module.exports = {
      id: "cloud-usage",
      viewBox: "0 0 24.6 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_price_versions/sprite.ce6f763a.svg#cloud-usage",
      toString: function () {
        return this.url;
      }
    }